import { useAuth } from "@stardeck-customer-apps/project-auth";
import { Link } from "react-router-dom";

import { Layout } from "@/components/layout";

export function Unauthorized() {
  const { user, isLoading, signOut } = useAuth();

  if (isLoading) {
    return (
      <Layout>
        <section className="mx-auto max-w-4xl px-8 pt-20 pb-16">
          <p className="text-text-muted">Loading...</p>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="mx-auto max-w-4xl px-8 pt-20 pb-16">
        <p className="text-[11px] text-text-muted tracking-wide-caps uppercase mb-6">Error 403</p>
        <h1 className="text-[44px] font-bold text-primary leading-[1.15] mb-4 tracking-tight">
          Unauthorized
        </h1>
        <p className="text-[15px] text-text-secondary leading-relaxed max-w-lg mb-6">
          You don't have permission to access this resource.
        </p>

        {user && (
          <div className="mb-8 p-4 border border-border bg-card">
            <p className="text-[13px] text-text-tertiary">
              <span className="text-text-secondary">Signed in as:</span> {user.email}
            </p>
          </div>
        )}

        <div className="flex gap-4">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-primary text-primary-foreground font-bold text-[14px] hover:opacity-90 transition-opacity"
          >
            Return Home
          </Link>
          <button
            onClick={() => signOut()}
            className="px-6 py-3 border border-border text-text-secondary font-bold text-[14px] hover:border-border-hover transition-colors"
          >
            Sign Out
          </button>
        </div>
      </section>
    </Layout>
  );
}
